import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "q-pa-lg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-body1 text-weight-bold q-mb-sm" }, " Request New Posts ", -1)
const _hoisted_3 = { class: "text-body1" }
const _hoisted_4 = {
  key: 0,
  class: "text-body1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_user = _resolveComponent("app-user")!
  const _component_create_request_btn = _resolveComponent("create-request-btn")!

  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("p", _hoisted_3, [
          _createTextVNode(" Send the client a request to import their latest "),
          _createElementVNode("strong", null, _toDisplayString(_ctx.account.socialSite.name), 1),
          _createTextVNode(" posts. ")
        ]),
        _createVNode(_component_app_user, null, {
          default: _withCtx(({ isCustomer }) => [
            isCustomer
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, " You will be notified by email when the posts are available for your review. "))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_create_request_btn, {
          account: _ctx.account,
          class: "q-mt-md"
        }, null, 8, ["account"])
      ]))
    : _createCommentVNode("", true)
}